import React from 'react';

import AuthenticationContext from './authentication';
import ProfileContext from './profile';

export default function MainContext({ children }) {
  return (
    <ProfileContext>
      <AuthenticationContext>{children}</AuthenticationContext>
    </ProfileContext>
  );
}
